import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const BalanceSummaryPage = () =>
  import('@/apps/adok/pages/balance-summary').then((m) => m.BalanceSummaryPage)
const BalanceInvoicesPage = () =>
  import('@/apps/adok/pages/balance-invoices').then(
    (m) => m.BalanceInvoicesPage
  )
const BalanceTopUpPage = () =>
  import('@/apps/adok/pages/balance-top-up').then((m) => m.BalanceTopUpPage)
const BalanceWithdrawalsPage = () =>
  import('@/apps/adok/pages/balance-withdrawals').then(
    (m) => m.BalanceWithdrawalsPage
  )

const balanceRoutes: RouteRecordRaw[] = [
  {
    path: '/balance',
    component: Layout,
    redirect: '/balance/summary',
    meta: { hidden: true },
    children: [
      {
        path: 'summary',
        name: 'balance-summary',
        component: BalanceSummaryPage,
        meta: {
          title: 'Balance'
        }
      },
      {
        path: 'top-up',
        name: 'balance-top-up',
        component: BalanceTopUpPage,
        meta: {
          title: 'Top Up balance'
        }
      },
      {
        path: 'top-up/:replenishmentMethodKey/new',
        name: 'balance-top-up-replenishment-new',
        component: BalanceTopUpPage,
        meta: {
          title: 'Top up',
          hidden: true
        }
      },
      {
        path: 'top-up/:replenishmentMethodKey/payment-profile',
        name: 'balance-top-up-payment-profile',
        component: BalanceTopUpPage,
        meta: {
          title: 'Payment profile',
          hidden: true
        }
      },
      {
        path: 'invoices',
        name: 'balance-invoices',
        component: BalanceInvoicesPage,
        meta: {
          title: 'Invoices'
        }
      },
      {
        path: 'withdrawals',
        name: 'balance-withdrawals',
        component: BalanceWithdrawalsPage,
        meta: {
          title: 'Withdraw balance'
        }
      },
      {
        path: 'withdrawals/approve',
        name: 'balance-withdrawals-approve',
        component: BalanceWithdrawalsPage,
        meta: {
          title: 'Withdraw balance',
          hidden: true
        }
      },
      {
        path: 'withdrawals/:withdrawalRequestId/activate',
        name: 'balance-withdrawals-activate',
        component: BalanceWithdrawalsPage,
        meta: {
          title: 'Withdraw balance',
          hidden: true
        }
      },
      {
        path: 'withdrawals/withdrawal-option',
        name: 'balance-withdrawals-withdrawal-option-edit',
        component: BalanceWithdrawalsPage,
        meta: {
          title: 'Payout settings',
          hidden: true
        }
      },
      {
        path: 'withdrawals/:paymentMethodId/withdrawal',
        name: 'balance-withdrawals-withdrawal-new',
        component: BalanceWithdrawalsPage,
        meta: {
          title: 'Request payout',
          hidden: true
        }
      },
      {
        path: 'withdrawals/:paymentMethodId/credentials',
        name: 'balance-withdrawals-credentials-edit',
        component: BalanceWithdrawalsPage,
        meta: {
          title: 'Payment details',
          hidden: true
        }
      }
    ]
  }
]

export default balanceRoutes
